export const fileSafe = (value: string) =>
  value
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '') || 'chart'

export const loadImage = (src: string) =>
  new Promise<HTMLImageElement>((resolve, reject) => {
    const image = new Image()
    image.onload = () => resolve(image)
    image.onerror = reject
    image.src = src
  })

export const downloadBlob = (blob: Blob, filename: string) => {
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}

export const dataUrlToBlob = (dataUrl: string) => {
  const [metadata, encodedData] = dataUrl.split(',')
  const mimeType = metadata.match(/:(.*?);/)?.[1] ?? 'application/octet-stream'
  const binary = atob(encodedData)
  const buffer = new Uint8Array(binary.length)
  for (let byteIndex = 0; byteIndex < binary.length; byteIndex += 1) {
    buffer[byteIndex] = binary.charCodeAt(byteIndex)
  }
  return new Blob([buffer], { type: mimeType })
}
